/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { BiLoaderAlt } from "react-icons/bi";
import { useTranslation } from "react-i18next";
import Sorting from "../../../Common/Sorting";
import MetaHead from "../../../Common/Metahead";
import { sortingAPIList } from "../../../../utilities/enums";
import Search from "../../../Common/Search";
import { connect } from "react-redux";
import Paginations from "../../../Common/Pagination";
import { campaignList } from "../../../../stores/actions/campaign.actions.types";
import CampaignTable from "../../../Tables/CampaignTable";
import AddSmsCampaign from "../../../Modals/add-sms-campaign";

const PendingSMSCampaignPage = ({ campaignList }) => {
  const { t } = useTranslation();

  const [pagination, setPagination] = useState({ page: 1, total: 0 });
  const [campaigns, setCampaigns] = useState([]);
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [recepientCount, setRecepientCount] = useState({});
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState([
    {
      whom: "updatedAt",
      order: "desc",
    },
  ]);

  useEffect(() => {
    setLoading(true);
    getCampaigns(pagination.page, sorting, search);
  }, [sorting, pagination.page, search, reload]);

  const getCampaigns = (page, sort, search) => {
    const callback = (data) => {
      if (data.success) {
        const { total, pages, campaigns, recepientCount } = data?.data;

        setPagination((prev) => ({
          ...prev,
          total: total || 0,
          pages: pages || 1,
        }));

        setCampaigns(campaigns);
        setRecepientCount(recepientCount);
        setLoading(false);
      } else {
        setLoading(false);
      }
    };

    let request = {
      callback,
      data: { type: "pending-sms", page, sort, q: search },
    };
    campaignList(request);
  };

  const handleChangeSorting = (value) => {
    const sort = JSON.parse(value);
    setSorting([sort]);
  };

  return (
    <div>
      <MetaHead title={t("sms-campaign-list")} />

      <div className='flex mt-10 mb-3 w-full justify-between'>
        {loading ? (
          <div></div>
        ) : (
          <div className='flex items-center gap-2'>
            <div className='border dark:border-gray-300 border-gray-800 rounded-full px-4 py-1 text-sm '>
              <h2>Total Pending Orders ({recepientCount?.pendingOrders})</h2>
            </div>
          </div>
        )}

        <div className='flex flex-col sm:flex-row justify-end  gap-2'>
          <Search
            placeholder='Campaign Name'
            search={search}
            setSearch={setSearch}
          />
          <Sorting
            name={"Sort"}
            values={sortingAPIList}
            onChange={handleChangeSorting}
          />
          <AddSmsCampaign
            type={"pending-sms"}
            setReload={setReload}
            reload={reload}
          />
        </div>
      </div>

      {loading ? (
        <div className='flex rounded dark:bg-boxdark bg-white items-center justify-center min-h-96'>
          <BiLoaderAlt className='animate-spin text-4xl text-primary dark:text-white' />
        </div>
      ) : campaigns?.length ? (
        <div>
          <CampaignTable
            campaigns={campaigns}
            setCampaigns={setCampaigns}
            reload={reload}
            setReload={setReload}
          />
          <Paginations pagination={pagination} setPagination={setPagination} />
        </div>
      ) : (
        <div className='flex rounded dark:bg-boxdark bg-white items-center justify-center min-h-96'>
          Not found
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.app.visible,
});

export default connect(mapStateToProps, {
  campaignList,
})(PendingSMSCampaignPage);
